import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import AddListItemButton from '../../../inputs/AddListItemButton';
import TabEditTabProperties from './TabEditTabProperties';
import { addNewVehicleColumnID, addNewVehicleColumn } from '../../../actions/apiDepartmentUpdates';
import { addTabProperty, deleteTabProperty } from '../../../actions/apiDealerUpdates';

const EditTabCheckboxes = (props) => {
    const [errors, setErrors] = useState({ addDepartmentPropertyError: false });
    const [optionName, setOptionName] = useState('');
    const [vehicleColumnId, setVehicleColumnId] = useState('');

    const vehicleColumns = useSelector(state => state.settings_departments.vehicle_columns);
	const all_tabs = useSelector(state => state.settings_site.all_tabs);
	const getTabByName = () => {
		const value = _.sortBy(_.filter(all_tabs, o => o.name === props.tab.name), 'id');
		return value[0];
	};

	const tab = getTabByName();
    const installation = useSelector(state => state.settings_dealerships.installation);
    const dispatch = useDispatch();

    const addNewVehicleColumn = useCallback(() => {
        const input_name = 'switch-needed';
        let name = optionName;
        name = name.toLowerCase();
        const errorType = 'add new vehicle column';
        const data = { name, input_name };

        return dispatch(addNewVehicleColumnID(data, errorType)).then(resp => {
            setVehicleColumnId(resp);
            return resp;
        });
    }, [dispatch, optionName]);

    const onChange = (e) => {
        setOptionName(e.target.value);
    };

    const onClick = () => {
        name = optionName.toLowerCase();
        const vehicle_column = _.find(vehicleColumns, { name });

        if (vehicle_column) {
            const data = {
                vehicle_column_id: vehicle_column.id,
                tab_id: tab.id,
                name,
            };
            setOptionName('');
            dispatch(addTabProperty(data, 'addTabProperty'));
        } else {
            addNewVehicleColumn().then(resp => {
                const data = {
                    vehicle_column_id: resp,
                    tab_id: tab.id,
                    name,
                    dealership: installation.subdomain,
                };
                setOptionName('');
                dispatch(addTabProperty(data, 'addTabProperty'));
            }).catch(ex => console.error(ex));
        }
    };

    const onDelete = (e) => {
        const { id } = e.target.dataset;
        dispatch(deleteTabProperty(id, 'Delete Tab Property'));
    };

    return (
        <div className="col-md-12">

            <h3 className="text-center">Checkbox/Ribbon Settings</h3>
            <div className="card space-top-1">
                <div className="card-text">
                    <h3>Tab Property Settings</h3>
                    <div className="col-md-6">
                        <small>
                            <i className={'fa fa-info-circle text-info'} />
                            {' '}
                            Choose from an existing vehicle column or create a new column and then add it to the list.
                        </small>
                        <AddListItemButton 
                            field={'option_name'} 
                            value={optionName} 
                            label={'test'} 
                            error={errors.addDepartmentPropertyError} 
                            type={'text'} 
                            onChange={onChange} 
                            onClick={onClick} 
                        />
                    </div>
                </div>
                </div>
        </div>
    );
};

export default EditTabCheckboxes;
